import React from "react";
import {observer} from "mobx-react";
import {GameFullScreenTapBox} from "./boxes/game-full-screen-tap.box";
import {OrbitComponentWithState} from "../../../../base-components/orbit-component-with-state/orbit-component-with-state";

interface GameFullScreenTapComponentState {
    wasClicked: boolean;
}

export const GameFullScreenTapComponent = observer(
    class GameFullScreenTapComponent extends OrbitComponentWithState<{}, GameFullScreenTapComponentState> {
        constructor(props) {
            super(props);
            this.state = {
                wasClicked: false
            };
        }

        private _enterFullScreen(): void {
            try {
                if(this._shouldEnterFullScreen) {
                    this.services.dom.enterFullScreen();
                }
            } catch (err){
                this.services.logger.error('Open game in full screen failed', err);
            }
        }

        private _onClickHandler = () => {
            this._enterFullScreen();

            this.setState({
                wasClicked: true
            });
        }

        private get _shouldEnterFullScreen(): boolean {
            return this.services.device.os.isAndroid
                    && !this.services.device.hybrid.isHybrid
                    && this.services.mediaQuery.sAndBelow;

        }

        componentDidMount() {
            super.componentDidMount();

            this._enterFullScreen();

            if(this._shouldEnterFullScreen) {
                //TODO - this reaction doesn't really work because the browser doesn't send fullscreenchange event when the user exit full screen. We will need to find a different way. See https://stackoverflow.com/questions/21103478/fullscreenchange-event-not-firing-in-chrome
                this.reaction(() => this.services.dom.isInFullScreen,
                    (isInFullScreen) => {
                        if(!isInFullScreen) {
                            this.setState({
                                wasClicked: false
                            });
                        }
                    });
            }
        }

        render() {
            if(!this._shouldEnterFullScreen) {
                return null;
            }

            if(this.services.dom.isInFullScreen) {
                return null;
            }

            if(this.state.wasClicked) {
                return null;
            }

            return (
                <GameFullScreenTapBox onClick={this._onClickHandler}/>
            );

        }
    }
);